import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large RegionsActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": "Вы действительно хотите удалить регион?",
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors,
        placeholder: "Название региона"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        value: _ctx.state.countryId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.countryId) = $event)),
        placeholder: "Выберите страну",
        "is-invalid": _ctx.state_form$.countryId.$error,
        "validation-errors": _ctx.state_form$.countryId.$errors,
        loading: _ctx.data_state.countries.is_loading,
        options: _ctx.data_state.countries.list,
        failed: _ctx.data_state.countries.is_failed,
        "error-text": "При получении списка стран произошла ошибка",
        "search-by": "title",
        "select-by": "id",
        label: "title",
        "infinite-scroll": "",
        onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadCountries(_ctx.data_state.countries.pagination.current_page))),
        onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreCountries(_ctx.data_state.countries.pagination.current_page + 1))),
        onSearch: _ctx.searchCountries,
        onOptionBySearch: _ctx.unshiftFindedCountry
      }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "is-confirm", "loading", "onCancel", "onConfirm"]))
}